import loadTicketsArray from "./loadTicketsArray";
import getRandomInt from "./getRandomInt";

async function generateExamBilet(categoryTickets) {
  const addToHeaderName = categoryTickets.substring(
    categoryTickets.length - 2,
    categoryTickets.length
  );

  let examTicket = { header: "Экзамен " + addToHeaderName, tasks: [] };
  const ticketsArray = await loadTicketsArray(categoryTickets);
  let ticketsLength = ticketsArray.length;
  let randomNumber;
  
  for (let i = 0; i < 20; i++) {
    randomNumber = getRandomInt(ticketsLength);
    examTicket.tasks.push({
      ...ticketsArray[randomNumber].tasks[i],
      ticketId: ticketsArray[randomNumber].ticketId,
    });
  }
  return examTicket;
}

export default generateExamBilet;
